import "./views/fd-pkgs/@fd-assets/carousel/shared/partials/_movieCarousel.js";